import {
  Users,
  Palette,
  Globe,
  Megaphone,
  Layout,
  TrendingUp
} from 'lucide-react';
export const SERVICES = [
  {
    id: 'community-management',
    title: 'Community Management',
    description: 'Gestion stratégique de vos réseaux sociaux pour bâtir une communauté engagée.',
    icon: Users,
    color: 'bg-blue-50 text-blue-600',
  },
  {
    id: 'content-creation',
    title: 'Création de Contenu',
    description: 'Production de visuels, vidéos et textes impactants adaptés à votre audience.',
    icon: Layout,
    color: 'bg-brand-lime/20 text-brand-purple',
  },
  {
    id: 'branding',
    title: 'Branding & Identité',
    description: 'Conception de logos et chartes graphiques qui reflètent votre essence unique.',
    icon: Palette,
    color: 'bg-purple-50 text-purple-600',
  },
  {
    id: 'web-dev',
    title: 'Création de Site Web',
    description: 'Sites vitrines et e-commerce modernes, optimisés pour la conversion et le mobile.',
    icon: Globe,
    color: 'bg-indigo-50 text-indigo-600',
  },
  {
    id: 'digital-marketing',
    title: 'Marketing Digital',
    description: 'Campagnes publicitaires ciblées (Ads) pour maximiser votre retour sur investissement.',
    icon: Megaphone,
    color: 'bg-orange-50 text-orange-600',
  },
  {
    id: 'growth-strategy',
    title: 'Stratégie de Croissance',
    description: 'Audit et conseil pour accélérer votre visibilité et vos ventes en ligne.',
    icon: TrendingUp,
    color: 'bg-green-50 text-green-600',
  },
];
export const PORTFOLIO_PROJECTS = [
  {
    id: 'p1',
    title: "Boutique E-commerce Luxe",
    category: "Web Design",
    description: "Refonte complète de l'expérience utilisateur pour une marque de maroquinerie haut de gamme au Sénégal.",
    fullDescription: "Ce projet visait à moderniser l'image digitale d'une maroquinerie dakaroise renommée tout en optimisant le parcours d'achat pour une clientèle internationale exigeante.",
    challenge: "Le site précédent souffrait d'un taux d'abandon de panier de 75% et d'une image de marque vieillissante qui ne justifiait pas les tarifs premium.",
    solution: "Mise en place d'une interface minimaliste 'Mobile-First', intégration de paiements locaux (Orange Money/Wave) et photographie produit haute définition.",
    results: "Augmentation de 45% du taux de conversion et réduction du temps de chargement de 3s à 0.8s.",
    img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=1200",
    tags: ["E-commerce", "UX/UI", "Next.js"]
  },
  {
    id: 'p2',
    title: "Campagne de Branding 2024",
    category: "Branding",
    description: "Identité visuelle et stratégie de lancement pour une startup Fintech panafricaine.",
    fullDescription: "Lancement d'une nouvelle identité visuelle pour une application de transfert de fonds transfrontalier ciblant la diaspora.",
    challenge: "Créer une marque qui inspire une confiance absolue tout en restant dynamique et accessible aux jeunes générations technophiles.",
    solution: "Design d'un logotype symbolisant le flux et la connexion, palette chromatique 'Trust Blue' et campagne d'influence massive.",
    results: "+200k utilisateurs actifs en 3 mois et une reconnaissance de marque de 65% dans le segment cible.",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200",
    tags: ["Logotype", "Stratégie", "Content"]
  },
  {
    id: 'p3',
    title: "Série Social Media Impact",
    category: "Community Management",
    description: "Gestion et création de contenu pour une institution culturelle de Dakar, augmentant l'engagement de 150%.",
    fullDescription: "Accompagnement annuel pour la gestion de l'image sociale d'un centre culturel majeur.",
    challenge: "Maintenir l'intérêt du public entre les grands événements et rajeunir l'audience sans aliéner les partenaires institutionnels.",
    solution: "Production hebdomadaire de formats courts (Reels/TikTok) mettant en avant les coulisses et l'aspect humain de l'institution.",
    results: "Augmentation de l'engagement de 150% et une hausse de 30% des ventes de billets via les liens sociaux.",
    img: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?auto=format&fit=crop&q=80&w=1200",
    tags: ["Social Media", "Video", "Engagement"]
  },
  {
    id: 'p4',
    title: "App Mobile Livraison",
    category: "App Dev",
    description: "Design et développement d'une interface mobile fluide pour un service de livraison express.",
    fullDescription: "Développement d'une application de logistique dernier kilomètre pour optimiser les tournées de livraison en milieu urbain dense.",
    challenge: "Complexité de la navigation GPS dans les zones sans adresses formelles et besoin d'une interface simple pour les livreurs.",
    solution: "Système de géolocalisation par repères visuels et interface à gros boutons manipulable avec des gants.",
    results: "Gain de productivité de 25% par livreur et satisfaction client notée 4.9/5 sur les stores.",
    img: "https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&q=80&w=1200",
    tags: ["Mobile", "Design", "Product"]
  }
];
export const TESTIMONIALS = [
  {
    id: 't1',
    content: "L'équipe de khalil & Co a transformé notre présence en ligne. Leur compréhension du marché sénégalais est un atout majeur.",
    author: "Ricardo Juan",
    role: "CEO, Africa Tech Solutions",
    avatar: "https://i.pravatar.cc/150?u=joseline"
  },
  {
    id: 't2',
    content: "Une créativité sans limites et un professionnalisme exemplaire. Notre site web est maintenant notre meilleur outil de vente.",
    author: "Joseline Ndiaye",
    role: "Directrice Marketing, Sahel Fashion",
    avatar: "https://i.pravatar.cc/150?u=awa"
  },
  {
    id: 't3',
    content: "Leur approche data-driven nous a permis d'optimiser nos coûts publicitaires tout en triplant nos conversions.",
    author: "Eveline Faye",
    role: "Fondateur, Dakar Food Express",
    avatar: "https://i.pravatar.cc/150?u=ibrahima"
  }
];